<div class="tab-container">
  <lib-button [cssType]="'btn-secondary'"  [text]="'File Upload'" [size]="'small'" (click)="fileUpload()"></lib-button>
  <lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
</div>
